<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="EBook-Break" id="_idParaDest-6"> </p>
<p class="BT1stPara ParaOverride-1"><span class="CharOverride-2">For Alise</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43515.vue?13d9ada0